/*eslint-disable*/
import request from '@/api/request'

/**
 * 获取分类列表
 */
export const getFaceClassListPage = (params) => {
  return request({
    url: 'radioweb/app/web/getFaceClassListPage',
    method: 'get',
    params
  })
}
/**
 * 获取年份列表
 */
export const getClassYearListPage = (params) => {
  return request({
    url: 'radioweb/app/web/getClassYearListPage',
    method: 'get',
    params
  })
}
/**
 * 获取学时列表
 */
export const getClassHourListPage = (params) => {
  return request({
    url: 'radioweb/app/web/getClassHourListPage',
    method: 'get',
    params
  })
}
/**
 * 获取面授班级列表
 */
export const getClassListPage = (params) => {
  return request({
    url: 'radioweb/app/web/getClassListPage',
    method: 'get',
    params
  })
}
/**
 * 获取内训列表
 */
export const getListTrain = (params) => {
  return request({
    url: 'radioweb/app/train/getListPage',
    method: 'get',
    params
  })
}
/**
 * 获取班级详情
 */
export const getClassDescById = (params) => {
  return request({
    url: 'radioweb/app/web/getClassDescById',
    method: 'get',
    params
  })
}
/**
 * 获取班级详情
 */
export const getClassDescEsById = (params) => {
  return request({
    url: 'radioweb/app/web/getClassDescEsById',
    method: 'get',
    params
  })
}